import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.084 14.291h-.611q-.344 0-.683.052L14.33 9.5l1.547-1.482a.917.917 0 0 0-1.267-1.324l-3.826 3.662a.914.914 0 0 1-1.4-.124c-.25-.348-.174-.894.155-1.223l4.31-4.06c.817-.767 2.094-.955 3.093-.453l2.123 1.061a4.6 4.6 0 0 0 2.05.483h.967a.916.916 0 1 0 0-1.833h-.968c-.424 0-.85-.1-1.23-.29l-2.121-1.061c-1.672-.837-3.807-.526-5.171.759l-.566.533-.642-.584a4.58 4.58 0 0 0-3.108-1.19 4.6 4.6 0 0 0-2.041.481L4.115 3.916c-.38.19-.807.29-1.231.29h-.966a.916.916 0 1 0 0 1.833h.968c.706 0 1.416-.167 2.05-.483l2.122-1.061c.937-.471 2.253-.344 3.093.423l.538.49-2.425 2.285c-.984.983-1.14 2.536-.365 3.61.477.663 1.423 1.154 2.24 1.154.727 0 1.425-.286 1.929-.791l.922-.883 5.817 4.362-5.681 4.26a1.84 1.84 0 0 1-2.265-.01l-5.583-4.188a4.6 4.6 0 0 0-2.75-.917h-.611a.916.916 0 1 0 0 1.833h.611c.591 0 1.177.196 1.65.55l5.57 4.179a3.67 3.67 0 0 0 2.257.775c.79 0 1.579-.256 2.233-.765l5.586-4.188a2.76 2.76 0 0 1 1.649-.55h.611a.916.916 0 1 0 0-1.833"
    }, null, -1)
  ]))]))
}
export default { render: render }